// Module
var code = "<md-button ng-click=\"$ctrl.navPush()\" class=\"navigation-icon-btn md-icon-button\"> <md-tooltip md-delay=\"650\">{{ 'CREATE_NEW_CONTACT' | translate }}</md-tooltip> <md-icon class=\"md-light\">add</md-icon> </md-button> ";
// Exports
export default code;